import { subDays } from "date-fns"

/**
 * Creates a date query string with start date (first day of current month),
 * end date (last day of current month), and current date
 *
 * @returns String like "&startDate=2025-02-01&endDate=2025-02-28&date=2025-02-25"
 */
export function createDateQueryString(): string {
  const today = new Date()

  // Get first day of current month
  const startDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  )

  // Get last day of current month
  const endDate = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  )

  const startDateStr = formatDate(startDate)
  const endDateStr = formatDate(endDate)
  const todayStr = formatDate(today)

  return `startDate=${startDateStr}&endDate=${endDateStr}&date=${todayStr}`
}

const formatDate = (date: Date) => {
  return date.toISOString().split("T")[0]
}

export const getMonthDateRangeInUrlParams = (
  month: string,
  year: number
) => {
  const monthMap: { [key: string]: number } = {
    JAN: 0,
    FEV: 1,
    MAR: 2,
    ABR: 3,
    MAI: 4,
    JUN: 5,
    JUL: 6,
    AGO: 7,
    SET: 8,
    OUT: 9,
    NOV: 10,
    DEZ: 11,
  }
  const monthUpper = month.toUpperCase()
  const monthNumber = monthMap[monthUpper]
  const startDate = new Date(year, monthNumber, 1)
  const endDate = new Date(year, monthNumber + 1, 0)

  return `&paymentDateInit=${formatDate(startDate)}&paymentDateEnd=${formatDate(endDate)}`
}

export const getLast2MonthDateRange = () => {
  const today = new Date()
  const startDate = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  )
  const endDate = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  )
  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  }
}

export const getCurrentMonthDateRange = () => {
  const today = new Date()
  const startDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  )
  const endDate = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  )
  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  }
}

export const getCommissionsLast2PaymentMonthRangeParams =
  () => {
    const { startDate, endDate } = getLast2MonthDateRange()
    return `&paymentDateInit=${startDate}&paymentDateEnd=${endDate}`
  }

export const getCommissionsCurrentPaymentMonthRangeParams =
  () => {
    const { startDate, endDate } =
      getCurrentMonthDateRange()
    return `&paymentDateInit=${startDate}&paymentDateEnd=${endDate}`
  }

export const getDaysLateGroup = (range: string) => {
  const rangeMap: { [key: string]: string } = {
    "0-10 dias": "1-10",
    "11-20 dias": "11-20",
    "21-30 dias": "21-30",
    "Mais de 30 dias": "30-*",
  }

  return rangeMap[range] || "1-10"
}

export const getCurrentDay = () => {
  return new Date().toISOString().slice(0, 10)
}

export const getDefaulterCurrentDayRange = () => {
  return `&paymentDateInit=${getCurrentDay()}&paymentDateEnd=${getCurrentDay()}`
}

export const getChargesCurrentDayRange = () => {
  return `&createdAtInit=${getCurrentDay()}&createdAtEnd=${getCurrentDay()}`
}

export const getLastBusinessDay = () => {
  const today = new Date()
  const lastBusinessDay = subDays(today, 1)

  if (lastBusinessDay.getDay() === 0) {
    return formatDate(subDays(lastBusinessDay, 2))
  }
  if (lastBusinessDay.getDay() === 6) {
    return formatDate(subDays(lastBusinessDay, 1))
  }

  return formatDate(lastBusinessDay)
}

export const get7LastDaysRange = () => {
  const today = new Date()
  const sevenDaysAgo = subDays(today, 7)
  return {
    startDate: formatDate(sevenDaysAgo),
    endDate: formatDate(today),
  }
}

export const getChargesLast7DaysRangeParams = () => {
  const { startDate, endDate } = get7LastDaysRange()
  return `&createdAtInit=${startDate}&createdAtEnd=${endDate}`
}

export const getChargesLast2BusinessDays = () => {
  const lastBusinessDay = getLastBusinessDay()
  return `&createdAtInit=${lastBusinessDay}&createdAtEnd=${getCurrentDay()}`
}
